import React, { FC, Fragment } from 'react';
import { LegalCharges } from '../../../Components/sale-experiment/legal-charges/legal-charges';
import AppCard from '../../../Components/ui/card/AppCard';
import {
  AppAutocompleteInput,
  AppDateTimeInput,
  AppNumberInput,
  AppTextInput,
} from '../../../Components/ui/input';
import AppDivider from '../../../Components/ui/layout/AppDivider';
import { SaleMode, SaleType } from '../../../utils/constants';
import { maxValue } from '../../../utils/validators';

interface RetailProps {
  formData: Record<string, any>;
  mode: string;
  selectedItem: Record<string, any>;
  record: Record<string, any>;
}

const Retail: FC<RetailProps> = ({ formData, mode, selectedItem, record }) => {
  const { fkSaleMode } = formData;

  return fkSaleMode === SaleMode.Retail ? (
    <AppCard
      title="Informazioni sulla vendita al dettaglio"
      expanded={true}
      disabled={mode === 'show'}
    >
      <AppAutocompleteInput
        label="Tipo di vendita"
        source="fkSaleType"
        reference="sale-types"
        optionText="description"
        md={4}
        defaultValue={SaleType.ByAgent}
      />
      <AppDivider />
      <AppNumberInput
        label="Prezzo di vendita al pezzo"
        source="priceApiece"
        isAmount
        md={3}
        validate={[maxValue('priceTotal')]}
        required
      />
      <AppNumberInput label="Prezzo di vendita di listino" source="priceTag" isAmount md={3} />
      <AppNumberInput
        label="Prezzo di vendita totale"
        source="priceTotal"
        isAmount
        md={2}
        required
      />
      <AppDateTimeInput source="retailStartAt" label="Data/ora inizio vendita" md={2} required />
      <AppDateTimeInput source="retailEndAt" label="Data/ora fine vendita" md={2} required />
      <AppDivider />
      <LegalCharges mode={mode} record={record} selectedItem={selectedItem} saleMode={fkSaleMode} />
      <AppDivider />
      <AppTextInput source="saleAddress" label="Luogo della vendita" md={12} required />
    </AppCard>
  ) : (
    <Fragment />
  );
};

export default Retail;
